export const isFreeMode = process.env.REACT_APP_FREE_MODE === "true";
